/* eslint-disable import/prefer-default-export */
import styled from "styled-components";

export const Container = styled.div`
  padding: 24px 32px;

  .page-header {
    margin-bottom: 24px;

    .page-title {
      font-size: 34px;
      color: #3d3b48;
      margin: 0 0 8px 0;
    }

    .page-subtitle {
      font-size: 16px;
      color: ${({ theme }) => theme.primary70};
      margin: 0;
    }
  }

  .content-tabs {
    background: #fff;

    .ant-tabs-tab {
      padding: 12px 20px;
      font-size: 15px;
    }

    .ant-tabs-nav {
      margin-bottom: 24px;
    }

    .tab-content {
      .ant-table {
        font-size: 14px;
      }

      .ant-table-thead > tr > th {
        background: ${({ theme }) => theme.primaryLight};
        font-weight: 600;
        padding: 16px;
      }

      .ant-table-tbody > tr > td {
        padding: 16px;
      }

      .ant-table-tbody > tr:hover > td {
        background: ${({ theme }) => theme.primaryLight}20;
      }
    }
  }

  .table-filter {
    margin: 10px 20px 10px 0;
  }
  
  .table-search {
    max-width: 50%;
  }
`;
